import moment from 'moment';
import {
	GET_BOOKING_FILTERS,
	GET_BOOKINGS_VIEW_TYPE,
	GET_SELECTED_BOOKING,
	SET_BOOKING_FILTERS,
	SET_BOOKINGS_VIEW_TYPE,
	SET_SELECTED_BOOKING
} from './actionTypes';

const selectedMonth = moment(new Date()).format('YYYY-MM');

const initialState = {
	filters: [
		{
			name: 'Month',
			value: moment(new Date(selectedMonth)).format('YYYY-MM'),
			label: moment(new Date(selectedMonth)).format('MMMM YYYY'),
			icon: 'mdi mdi-calendar-month',
			canremove: false,
			type: 'month'
		}
	],
	selectedBookingId: null,
	bookingViewType: 'grid'
};

const BookingFilters = (state = initialState, action) => {
	switch (action.type) {
		case SET_BOOKING_FILTERS:
			return {
				...state,
				filters: action.payload
			};
		case GET_BOOKING_FILTERS:
			return {
				...state
			};
		case SET_SELECTED_BOOKING:
			return {
				...state,
				selectedBookingId: action.payload
			};
		case GET_SELECTED_BOOKING:
			return {
				...state
			};
		case SET_BOOKINGS_VIEW_TYPE:
			return {
				...state,
				bookingViewType: action.payload
			};
		case GET_BOOKINGS_VIEW_TYPE:
			return {
				...state
			};
		default:
			return { ...state };
	}
};

export default BookingFilters;
